import moment from 'moment';
import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { forceString } from 'src/utils/datetime';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

const mapCancellationProofs = ({
  attributes,
  id,
}: {
  attributes: UCM.CancellationProofRawType;
  id: string;
}): UCM.CancellationProofType => ({
  id,
  uuid: attributes.uuid,
  userId: attributes.user_id,
  cancellationNoticeId: attributes.cancellation_notice_id,
  firstDayOfSickness: attributes.first_day_of_sickness
    ? forceString(attributes.first_day_of_sickness, moment.HTML5_FMT.DATE)
    : null,
  contentType: attributes.proof?.content_type,
  fileName: attributes.proof?.file_name,
  url: attributes.proof?.url,
  user: {
    id: attributes.user.id,
    uuid: attributes.user.uuid,
    firstName: attributes.user.first_name,
    lastName: attributes.user.last_name,
  },
  cancellationNotice: {
    id: attributes.cancellation_notice.id,
    shiftDates: attributes.cancellation_notice.shift_dates,
    explanation: attributes.cancellation_notice.explanation,
    reason: attributes.cancellation_notice.reason,
  },
  job: {
    id: attributes.job.id,
    projectUuid: attributes.job.project_uuid,
  },
  proof: {
    fileName: attributes.proof.file_name,
    contentType: attributes.proof.content_type,
    url: attributes.proof.url,
  },
  healthInsurance: attributes.health_insurance,
});

const getCancellationProof = async (uuid: string) => {
  const {
    data: { data },
  } = await getRequest(API.GET.getCancellationProof(uuid));
  return mapCancellationProofs(data);
};

export const useGetCancellationProof = ({
  uuid,
  enabled = true,
}: {
  uuid: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.VERIFICATION_CANCELLATION_PROOF, uuid],
    queryFn: () => getCancellationProof(uuid),
    enabled,
  });
};
